import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const PhotoIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon className='' {...props}>
            <svg version="1.1" id="Capa_1" x="0px" y="0px"
                 viewBox="-69 141 552 512">
<g>
	<path fill="#3D4977" d="M405.64,241.693h-80.693v-0.972c0-12.152-4.861-23.819-13.125-31.596l0,0
		C303.559,200.861,292.379,196,280.227,196h-145.83c-12.639,0-23.819,4.861-32.083,13.125l0,0
		c-8.264,8.264-13.125,19.444-13.125,31.596v0.972H8.983c-16.041,0-30.138,6.319-40.346,17.013
		c-10.208,10.208-17.013,24.791-17.013,40.346v242.078c0,16.041,6.319,30.138,17.013,40.346
		c10.208,10.208,24.791,17.013,40.346,17.013H405.64c16.041,0,30.138-6.319,40.346-17.013C456.195,571.269,463,556.686,463,541.131
		V299.053c0-16.041-6.319-30.138-17.013-40.346C435.778,248.013,421.681,241.693,405.64,241.693z M437.237,541.131
		c0,8.75-3.403,16.527-9.236,22.361c-5.833,5.833-13.611,9.236-22.361,9.236H8.983c-8.75,0-16.527-3.403-22.361-9.236
		c-5.833-5.833-9.236-13.611-9.236-22.361V299.053c0-8.75,3.403-16.527,9.236-22.361c5.833-5.833,13.611-9.236,22.361-9.236H102.8
		c7.291,0,13.125-5.833,13.125-13.125v-14.097c0-5.347,1.944-10.208,5.347-13.611l0,0l0,0c3.403-3.403,8.264-5.347,13.611-5.347
		h145.344c5.347,0,10.208,1.944,13.611,5.347c3.403,3.403,5.347,8.264,5.347,13.611v14.097c0,7.291,5.833,13.125,13.125,13.125
		h93.817c8.75,0,16.527,3.403,22.361,9.236c5.833,5.833,9.236,13.611,9.236,22.361v242.078H437.237z"/>
    <path fill="#3D4977" d="M207.312,300.511c-33.055,0-63.193,13.611-84.581,34.999
		c-21.874,21.874-34.999,51.527-34.999,84.581s13.611,63.193,34.999,84.581c21.874,21.874,51.527,34.999,84.581,34.999
		s63.193-13.611,84.581-34.999c21.874-21.874,34.999-51.527,34.999-84.581s-13.611-63.193-34.999-84.581
		C270.505,314.122,240.366,300.511,207.312,300.511z M273.421,486.688c-17.013,16.527-40.346,27.222-66.11,27.222
		s-49.096-10.694-66.11-27.222c-17.013-17.013-27.222-40.346-27.222-66.11c0-25.763,10.694-49.096,27.222-66.11
		c17.013-17.013,40.346-27.222,66.11-27.222s49.096,10.694,66.11,27.222c17.013,17.013,27.222,40.346,27.222,66.11
		C301.129,446.341,290.435,469.674,273.421,486.688z"/>
    <circle fill="#3D4977" cx="380.363" cy="323.844" r="23.819"/>
</g>
</svg>
        </SvgIcon>
    )
};

export default PhotoIcon;